export default __webpack_public_path__ + "static/media/expansion.a2be61a1.svg";